
import _flatten from 'lodash.flatten';
import { ADDON_TYPE } from '@shootsta/common-domain-data';
import { getCostValue } from '@shootsta/cost-parsing-utils';
import { CURRENCY_BY_ENTITY_CODE } from '../../../common/constants';
import { WORD_COUNT_RANGES } from '../components/AddonManagementModal/constants';

const currencySymbols = {
  AUS: 'AUD $',
  US: 'USD $',
  ASIA_US: 'USD $',
  SG: 'SGD $',
  UK: 'GBP £',
  EU: 'EUR €',
  HK: 'HKD $'
};

const currencyIcons = {
  AUS: '$',
  US: '$',
  ASIA_US: '$',
  SG: '$',
  UK: '£',
  EU: '€',
  HK: '$'
};

const FREE_LANGUAGES = ['EN'];

function getAddonKey({ addonType, addonValue }) {
  if (!addonValue) {return '';}

  // TODO: Get rid of this part of code when will be no more projects with SUPER_RUSH_EDIT addon
  // TODO: Fix other backward compatibility code related to SUPER_RUSH_EDIT addon
  /* istanbul ignore next */
  if (addonType === 'RUSH_EDIT' && addonValue.value === 'SUPER_RUSH_EDIT') {
    return addonValue.value;
  }
  //

  if (addonType === 'DURATION') {
    return addonValue.value !== 'STANDARD' ? addonValue.value : '';
  }

  if (addonType === 'CHROMA_KEY') {
    return addonValue.value ? 'CHROMA_KEY' : '';
  }

  if (addonType === 'VOICE_OVER_ARTISTS') {
    const duration = addonValue && addonValue.find((v) => v.duration)?.duration;
    const DURATIONS = WORD_COUNT_RANGES.map((it) => it.duration);

    if (!duration || !DURATIONS.includes(duration)) {
      return '';
    }
    return `VOICE_OVER_ARTISTS_${duration}`;
  }

  return addonType;
}

function isFreeLanguage({ language }) {
  return FREE_LANGUAGES.includes(language);
}

export function isFreeAddon({
  addonKey,
  addonValue,
  includedAddons
}) {
  if (includedAddons.includes(addonKey)) {return true;}

  if (addonValue && ['BURN_IN_CAPTIONS', 'SRT_CAPTIONS'].includes(addonKey)) {
    if (isFreeLanguage({ language: addonValue }) ||
    includedAddons.includes(`${addonKey}_${addonValue}`)) {return true;}
  }

  return false;
}

export function getCurrencySymbol(billingEntityCode) {
  return () => currencySymbols[billingEntityCode];
}

export function getCurrency(billingEntityCode) {
  return () => CURRENCY_BY_ENTITY_CODE[billingEntityCode];
}

export function getCurrencyIcons(billingEntityCode) {
  return () => currencyIcons[billingEntityCode];
}

export function getAddonsCostByType(addonsWithCosts, billingEntityCode) {
  return (
  { addonType, numberValue = false }) =>
  numberValue ?
  Number(addonsWithCosts[addonType].costs[billingEntityCode]) :
  `${currencySymbols[billingEntityCode]}${addonsWithCosts[addonType].costs[billingEntityCode]}`;
}

export function getCostForAddon({
  costs,
  billingEntityCode,
  numberValue




}) {
  if (!costs) {
    return numberValue ? 0 : `${currencySymbols[billingEntityCode]}0`;
  }
  return numberValue ? Number(costs[billingEntityCode]) : `${currencySymbols[billingEntityCode]}${costs[billingEntityCode]}`;
}

export function getAddonTotalCost({
  selectedValue,
  field



}) {
  if (Array.isArray(selectedValue)) {
    return selectedValue.
    reduce((accumulator, cost) => getCostValue(cost, field) + accumulator, 0);
  }
  return getCostValue(selectedValue, field);
}

function getCustomCost(
addonType,
customAddonCosts,
languageCode)
{
  const allCustomCostAddons = _flatten(customAddonCosts.
  map((it) => {
    const filteredAddons = it.addonValues.filter((av) => Boolean(av.costChanged));
    return filteredAddons.map((fa) => ({
      addonType: it.addonType,
      value: fa.value,
      cost: fa.cost
    }));
  }).
  filter((addon) => addon.length > 0));

  const defaultCostAddons = _flatten(customAddonCosts.
  map((it) => {
    const filteredAddons = it.addonValues.filter((av) => !av.costChanged);
    return filteredAddons.map((fa) => ({
      addonType: it.addonType,
      value: fa.value,
      cost: fa.cost
    }));
  }).
  filter((addon) => addon.length > 0));

  if ([ADDON_TYPE.ADDITIONAL_OUTPUT, ADDON_TYPE.VOICE_OVER_ARTIST].includes(addonType)) {
    const {
      cost: customCost = 0
    } = allCustomCostAddons.find((it) => it.addonType === addonType) || {};
    const {
      cost: defaultCost = 0
    } = defaultCostAddons.find((it) => it.addonType === addonType) || {};
    return customCost || defaultCost;
  }

  const { cost: customCost = 0 } = allCustomCostAddons.find((it) =>
  it.addonType === addonType && it.value === languageCode
  ) || {};

  const { cost: defaultCost = 0 } = defaultCostAddons.find((it) =>
  it.addonType === addonType && it.value === languageCode
  ) || {};

  return customCost || defaultCost;
}

function isAddonIncluded(
addonType,
customAddonCosts,
languageCode)
{
  const allIncludedAddons = _flatten(customAddonCosts.
  map((it) => {
    const filteredAddons = it.addonValues.filter((av) => av.cost === 0);
    return filteredAddons.map((fa) => ({ addonType: it.addonType, value: fa.value }));
  }).
  filter((addon) => addon.length > 0));

  if ([ADDON_TYPE.ADDITIONAL_OUTPUT, ADDON_TYPE.VOICE_OVER_ARTIST].includes(addonType)) {
    return Boolean(allIncludedAddons.find((it) => it.addonType === addonType));
  }

  return Boolean(allIncludedAddons.find((it) =>
  it.addonType === addonType && it.value === languageCode
  ));
}

export function getCustomCostForAddon({
  addonType,
  customAddonCosts,
  billingEntityCode,
  numberValue,
  languageCode






}) {
  if (isAddonIncluded(addonType, customAddonCosts, languageCode)) {
    return numberValue ? 0 : `${currencySymbols[billingEntityCode]}0`;
  }

  const customCost = getCustomCost(addonType, customAddonCosts, languageCode);

  return numberValue ? Number(customCost) : `${currencySymbols[billingEntityCode]}${customCost}`;
}

export default function getAddonsCost({
  billingEntityCode,
  includedAddons,
  addonsCosts,
  customAddonCosts





}) {
  return function addonsCost(
  addons,
  { numberValue } = {})
  {
    const totalCost = addons ? Object.keys(addons).reduce((total, addonType) => {
      const addonValue = addons[addonType];
      const addonKey = getAddonKey({ addonType, addonValue });

      if (!addonKey || addonKey === '__typename') {return total;}

      const { costs } = includedAddons.includes(addonKey) ? {} : addonsCosts[addonKey];

      if (!addonValue ||
      !Array.isArray(addonValue) && !addonValue.value ||
      addonType === '__typename') {
        return total;
      }

      if (Array.isArray(addonValue)) {
        return total + addonValue.reduce(
          (valueTotal, srt) => {
            if (!srt) {
              return valueTotal;
            }

            if (customAddonCosts.length) {
              return valueTotal + getCustomCostForAddon({
                addonType: addonKey,
                customAddonCosts,
                billingEntityCode,
                numberValue,
                languageCode: srt.value
              });
            }

            if (isFreeAddon({ addonKey, addonValue: srt.value, includedAddons })) {
              return valueTotal;
            }

            return valueTotal + getCostForAddon({ costs, billingEntityCode, numberValue: true });
          }, 0
        );
      }

      if (customAddonCosts.length) {
        return total + getCustomCostForAddon({
          addonType: addonKey,
          customAddonCosts,
          billingEntityCode,
          numberValue,
          languageCode: addonValue.value
        });
      }

      if (isFreeAddon({ addonKey, addonValue: addonValue.value, includedAddons })) {
        return total;
      }

      return total + getCostForAddon({ costs, billingEntityCode, numberValue: true });
    }, 0) : 0;

    // This won't work for Europeans who prefer $10.000,00 format instead of $10,000.00
    const strTotal = parseFloat(totalCost).toFixed(2).replace('.00', '');
    return numberValue ? totalCost : `${currencySymbols[billingEntityCode]}${strTotal}`;
  };
}